import gql from 'graphql-tag';

export const MODIFICA_CONTACTO_EMAIL = gql(`
    mutation getContratoById($emailRequest: ModificarContactoEmailRequestInput) {
        modificaEmail(emailRequest: $emailRequest) {
			id
            tipo
            idPropietario
            tipoPropietario
            fechaAlta
            valor{
                email
            }
        }
    }
`);

export const MODIFICA_CONTACTO_TELEFONO = gql(`
    mutation modificaContactoTelefono($telefonoRequest: ModificarContactoTelefonoRequestInput) {
        modificaTelefono(telefonoRequest: $telefonoRequest) {
			id
            tipo
            idPropietario
            tipoPropietario
            fechaAlta
            valor{
                telefono
            }
        }
    }
`);

export const MODIFICA_CONTACTO_DIRECCION = gql(`
    mutation modificaContactoDireccion ($direccionRequest: ModificarContactoDireccionRequestInput) {
        modificaDireccion(direccionRequest: $direccionRequest) {
            id
            tipo
            idPropietario
            tipoPropietario
            fechaAlta
            valor{
                tipoDireccion
                direccion
                localidad
                provincia
                codigoPostal
                pais
            }
        }
    }
`);


export const GET_CONTACTO_RESPONSE = gql(`
    query getContactoResponseById($id: Long) {
        getContactoResponseByIdContacto(idContacto: $id) {
            tipo
            id
            fechaAlta
            tipoPropietario
            idPropietario
        }
    }
`);

export const GET_CONTACTO_EMAIL = gql(`
    query getContactoEmailById($id: Long) {
        getContactoEmailByIdContacto(idContacto: $id) {
            tipo
            id
            fechaAlta
            tipoPropietario
            idPropietario
            valor{
                email
            }
        }
    }
`);

export const GET_CONTACTO_TELEFONO = gql(`
    query getContactoTelefonoById($id: Long) {
        getContactoTelefonoByIdContacto(idContacto: $id) {
            tipo
            id
            fechaAlta
            tipoPropietario
            idPropietario
            valor{
                telefono
            }
        }
    }
`);

export const GET_CONTACTO_DIRECCION = gql(`
    query getContactoDireccionById($id: Long) {
        getContactoDireccionByIdContacto(idContacto: $id) {
            tipo
            id
            fechaAlta
            tipoPropietario
            idPropietario
            valor{
                tipoDireccion
                direccion
                codigoPostal
                provincia
                pais
            }
        }
    }
`);

export const GET_CONTACTOS = gql(`
    query contactos($id: Long, $tipoPropietario: String, $idioma: String) {
        contactos(id: $id, tipoPropietario: $tipoPropietario) {
            telefonos{
                id
                activo
                valor{
                    telefono
                }
            }
            emails{
                id
                activo
                valor{
                 email
                }
            }
            direcciones{
                id
                activo
                valor{
                    tipoDireccion
                    direccion
                    localidad
                    provincia
                    codigoPostal
                    pais        
                }
                literalTipoVia(idioma: $idioma){
                    clave
                    valor
                }
                literalPais(idioma: $idioma){
                    clave
                    valor
                }
                literalProvincia(idioma: $idioma){
                    clave
                    valor
                }
            }
        }
    }
`);


export const ALTA_CONTACTO_TELEFONO = gql(`
    mutation altaTelefono ($altaTelefonoRequest: AltaContactoTelefonoRequestInput) {
        altaTelefono(altaTelefonoRequest: $altaTelefonoRequest) {
            id
            tipo
            idPropietario
            tipoPropietario
            fechaAlta
            valor{
                    telefono
            }
        }
    }
`);

export const ALTA_CONTACTO_EMAIL = gql(`
    mutation altaEmail($altaEmailRequest: AltaContactoEmailRequestInput) {
        altaEmail(altaEmailRequest: $altaEmailRequest) {
            id
            idPropietario
            tipoPropietario
            tipo
            fechaAlta
            valor{
               email
            }
        }
    }
`);

export const ALTA_CONTACTO_DIRECCION = gql(`
    mutation altaDireccion($altaDireccionRequest: AltaContactoDireccionRequestInput) {
        altaDireccion(altaDireccionRequest: $altaDireccionRequest) {
            id
            idPropietario
            tipoPropietario
            tipo
            fechaAlta
            valor{
                tipoDireccion
                direccion
                codigoPostal
                provincia
                pais
            }
        }
    }
`);

export const BORRAR_CONTACTO = gql(`
    mutation borrarContacto($id: Long) {
        borrarContacto(id: $id) {
            id
        }
    }
`);

export const LISTADO_TIPOS_VIA_DIRECCION = gql(`
    query listadoTiposViaDireccion ($idioma: String) {
        listadoTiposViaDireccion(idioma: $idioma) {
            clave
            valor
        }
    }
`);


export const LISTADO_PAISES = gql(`
    query listadoPaises ($idioma: String) {
        paises(idioma: $idioma) {
            clave
            valor
        }
    }
`);

export const LISTADO_PROVINCIAS_POR_PAIS = gql(`
    query listadoProvinciasPorPaises ($clavePais: String, $idioma: String) {
        provinciasPorPaises(clavePais: $clavePais, idioma: $idioma) {
            clave
            valor
        }
    }
`);

export const DETALLE_PROVINCIA_POR_CP = gql(`
    query getDetallePoblacion ($cp: String, $idioma: String) {
        getDetallePoblacion(cp: $cp, idioma: $idioma) {
            codigoPostal
            localidad
            codProvincia
            claveProvincia
            codPais
        }
    }
`);

export const AUTOCOMPLETE_POBLACION = gql(`
    query AutocompletePoblacion($prefix: String, $idioma: String) {
        autocompletePoblacion(prefix: $prefix, idioma: $idioma) {
            claveProvincia
            codPais
            codProvincia
            codigoPostal
            localidad
        }
    }
`);




